export const SET_LOADING = "SET_LOADING";
export const REMOVE_LOADING = "REMOVE_LOADING";
export const SET_USER_DATA = "SET_USER_DATA";
export const CLEAR_STORAGE = "CLEAR_STORAGE";
export const SET_REGIONS = "SET_REGIONS";
export const SET_PAYMENT_STATUS = "SET_PAYMENT_STATUS";
export const SET_PAYMENT_METHODS = "SET_PAYMENT_METHODS";
export const SET_EFD_MODELS = "SET_EFD_MODELS";
export const SET_EFD_STATUS = "SET_EFD_STATUS";
export const SET_ROLES = "SET_ROLES";
export const SET_OFFICES = "SET_OFFICES";
export const SET_VENDOR = "SET_VENDOR";
export const SET_BRAND = "SET_BRAND";
export const SET_MODAL = "SET_MODAL";
export const SET_USERS = "SET_USERS";
export const SET_REASON = "SET_REASON";
export const SET_DOCUMENTS = "SET_DOCUMENTS";
export const SET_EFDSTATUS = "SET_EFDSTATUS";
export const SET_DEVICE_STATUS = "SET_DEVICE_STATUS";
export const SET_TAX_GROUP = "SET_TAX_GROUP";
export const SET_PACKAGE_TYPE = "SET_PACKAGE_TYPE";
